import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import raw_en from "../about.txt";
import raw_af from "../about_af.txt";
import raw_fr from "../about_fr.txt";
import raw_pt from "../about_pt.txt";
import { pickContentLanguage } from "../contentLanguage";
import SharedStateContext from "../context/sharedstate";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";
import { useTranslation } from "react-i18next";
import "../i18n";
import { MathJax } from "better-react-mathjax";
import { AuthContext } from "../context/AuthContext";
import Logo from "../logo512.png";

// Claude: which raw-imported file to fetch per translated content language — see
// Claude: contentLanguage.js for which languages have a real translation.
const ABOUT_SOURCES = { en: raw_en, af: raw_af, fr: raw_fr, pt: raw_pt };

function About({ isLoggedIn, onLogout }) {
  const { auth } = useContext(AuthContext);
  const { interfaceLanguage } = useContext(SharedStateContext);
  const [aboutText, setAboutText] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const contentLanguage = pickContentLanguage(interfaceLanguage);

  useEffect(() => {
    fetch(ABOUT_SOURCES[contentLanguage])
      .then((response) => response.text())
      .then((text) => setAboutText(text));
  }, [contentLanguage]);

  return (
    <div className="min-h-screen bg-gray-100">
      {localStorage.setItem("bladsy","About")}
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}
      <div className="prose prose-lg p-4 max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="ml-0 bg-gray-500 text-white py-2 mt-4 mb-0 px-4 rounded-lg hover:bg-gray-600"
        >
          {t("back")}
        </button>
        <MathJax inline dynamic>
          <ReactMarkdown classname="prose">{aboutText}</ReactMarkdown>
        </MathJax>
      </div>
      <div className="flex flex-col justify-center items-center p-4">
        <Link to={"/"}>
          <img src={Logo} alt="Logo" width="100" height="100" />
        </Link>
      </div>
    </div>
  );
}

export default About;
